import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Observable} from "rxjs";
import UserModel from "../../../model/user.model";
import UserService from "../../../api/user/user.service";

@Component({
  selector: 'app-event-type-dialog',
  templateUrl: './event-type-dialog.component.html',
  styleUrls: ['./event-type-dialog.component.scss']
})
export class EventTypeDialogComponent implements OnInit{

  selectedEventType = 'event';
  eventTypeList: any[] = [
    {name: 'Kooperation Termin', type:'event'},
    {name: 'Private Termin', type:'privateEvent'},
  ];
  public user$: Observable<UserModel>;
  constructor(
      public dialogRef: MatDialogRef<EventTypeDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data,
      private userService: UserService
  ) {
    this.user$ = this.userService.user$;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.user$.subscribe(user=> {
      if(user.roles.length == 1 && user.roles[0] == 'ROLE_CRM_INFLUENCER') {
        this.eventTypeList.push({name: 'Influencer Urlaub', type:'vacation'})
      }
    })
  }
}
